<template>
  <!-- The block the property dashboard shows for a unit's own tours and screening, here for what new units start with -->
  <ListingSettingsCard
    tone="secondary"
    :tour-types="building.tourTypes"
    :screening-sensitivity="building.renterRequirements?.screeningSensitivity"
    @edit-tours="toursSheetRef?.show()"
    @edit-screening="screeningSheetRef?.show()"
  >
    <template v-if="building.tourTypes" #tours-note>
      <DefaultDriftLine :building-id="building.id" :differing-ids="building.defaultsDrift?.tourTypes" :units="units" />
    </template>
    <template v-if="building.renterRequirements?.screeningSensitivity" #screening-note>
      <DefaultDriftLine
        :building-id="building.id"
        :differing-ids="building.defaultsDrift?.screeningSensitivity"
        :units="units"
      />
    </template>

    <BuildingSectionSheet ref="toursSheetRef" title="Tour options" :hint="unitDefaultHint" :form="TourTypesForm" />
    <BuildingSectionSheet
      ref="screeningSheetRef"
      title="Screening sensitivity"
      :hint="unitDefaultHint"
      :form="ScreeningSensitivityForm"
    />
  </ListingSettingsCard>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import {
  BuildingDto,
  ListingSettingsCard,
  PropertyListItemDto,
  ScreeningSensitivityForm,
  TourTypesForm,
} from '@tallo/investor/property';

import BuildingSectionSheet from '../../../components/building-section-sheet.vue';
import DefaultDriftLine from '../default-drift-line.vue';
import { unitDefaultHint } from './unit-default.const';

/** The tours and screening a new unit starts with; the access method and ID checks are each unit's own */
defineProps<{ building: BuildingDto; units: PropertyListItemDto[] }>();

const toursSheetRef = ref<InstanceType<typeof BuildingSectionSheet>>();
const screeningSheetRef = ref<InstanceType<typeof BuildingSectionSheet>>();
</script>
